<template>
  <main>
    <menus/>
    <div class="cont" v-loading="loading">
      <ul>
        <li>
          <p class="head">优惠券名称</p>
          <p class="title">{{info.title}}</p>
        </li>
        <li>
          <p class="head">优惠券金额</p>
          <p class="price">{{info.amount}}</p>
        </li>
        <li>
          <p class="head">使用条件</p>
          <p class="desc">满{{info.min_consumption}}可用</p>
        </li>
        <li>
          <p class="head">有效期</p>
          <p class="desc">{{info.use_sdate}} 至 {{info.use_edate}}</p>
        </li>
        <li>
          <p class="head">适用产品<span>（点击产品立即适用）</span></p>
          <nav>
            <router-link tag="span" v-for="v in info.visaproducts" :key="v.product_id" :to="{name: 'visa_detail', query: { id: v.CountryID, detailId: v.product_id }}">{{v.product_name}}</router-link>
          </nav>
          <nav>
            <router-link tag="span" v-for="v in info.tourproducts" :key="v.product_id" :to="{path: '/tour/'+v.product_id}">{{v.product_name}}</router-link>
          </nav>
        </li>
      </ul>
    </div>
  </main>
</template>

<script>
import menus from '@components/menu';
import { mapState } from 'vuex';
export default {
  components: {
    menus
  },
  data () {
    return {
      info: {},
      loading: true,
    }
  },
  async created () {
  },
  filters: {
  },
  computed: {
    ...mapState([
      'userInfo'
    ]),
  },
  async created () {
    const { id } = this.$route.query;
    if ( !id ) { this.$router.push({ name: 'coupon_list' }); return; }
    const info = await this.$axios.get(`coupon/detail/${id}`);
    this.info = info;
    this.loading = false;
  },
  methods: {
  }
}
</script>

<style scoped src="./info.css"></style>
